import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BrowseListings from './pages/BrowseListings';
import PropertyDetail from './pages/PropertyDetail';
import ListProperty from './pages/ListProperty';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';
import UserDashboard from './pages/UserDashboard';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import DeleteAccount from './pages/DeleteAccount';
import AboutUs from './pages/AboutUs';
import FAQsPage from './pages/FAQsPage';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import { trackEvent } from './utils/analytics';
import GoogleAnalytics from './components/GoogleAnalytics';
import GoogleTagManager from './components/GoogleTagManager';
import MetaPixel from './components/MetaPixel';

const PageViewTracker = () => {
  const location = useLocation();
  useEffect(() => {
    trackEvent('page_view', null, location.pathname);
  }, [location.pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const removeBadge = () => {
      const el = document.getElementById('emergent-badge');
      if (el) el.remove();
    };
    removeBadge();
    const interval = setInterval(removeBadge, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <GoogleTagManager />
        <MetaPixel />
        <PageViewTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/properties" element={<BrowseListings key="all" />} />
          <Route path="/properties-for-sale" element={<BrowseListings key="buy" defaultType="buy" />} />
          <Route path="/properties-for-rent" element={<BrowseListings key="rent" defaultType="rent" />} />
          <Route path="/new-projects" element={<BrowseListings key="new" defaultType="new_projects" />} />
          <Route path="/browse" element={<BrowseListings key="browse" />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/list-property" element={<ListProperty />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<UserDashboard />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/faqs" element={<FAQsPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
